<template>
	<div class="test__question__drag-n-drop">
		<draggable
			v-model="choices"
			ghost-class="ghost"
			:options="{disabled: question.answerStatus !== null}"
		>
			<transition-group type="transition" name="flip-list">
					<div
						v-for="choice in choices"
						:key="'dragNDrop' + question.id + '__choice' + choice.id"
						:id="'dragNDrop' + question.id + '__choice' + choice.id"
						class="sortable"
						:class="{active: question.answerStatus === null}"
					>
						<div
							v-if="question.answerStatus === null"
							class="test__question__drag-n-drop__icon"
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 25.402 22.574">
								<path d="M13.488,22.646,1.789,15.68A1,1,0,0,1,2.3,13.82H25.7a1,1,0,0,1,.511,1.859l-11.7,6.966a1,1,0,0,1-1.023,0ZM2.3,9.18a1,1,0,0,1-.512-1.859L13.488.354a1,1,0,0,1,1.023,0l11.7,6.967A1,1,0,0,1,25.7,9.18Z" transform="translate(-1.299 -0.213)"/>
							</svg>
						</div>
						<div class="test__question__drag-n-drop__text">
							<v-runtime-template :template="choice.text" />
						</div>
					</div>
			</transition-group>
		</draggable>

		<div
			v-if="this.question.answerStatus === 'answeredIncorrectly'"
			class="d-flex justify-content-center flex-column align-items-center bg-warning px-3 pt-3 rounded mt-2"
		>
			<b>
				Správné pořadí:
			</b>
			<v-runtime-template :template="findAndRenderLaTeX(question.answer)" />
		</div>
	</div>
</template>


<script>
import { mapActions } from "vuex";

import draggable from 'vuedraggable'

export default {
	components: {
		draggable,
	},

	name: 'DragNDrop',

	props: ['questionIndex'],
	data() {
		return {
			question: null,

			choices: [],

			rightChoicesOrderArray: [],

			evaluation: {
				evaluated: false,
				isCorrect: null,
				message: null,
			},
		}
	},

	// Příprava dat před tím, než se začne cokoliv vykonávat
	created() {
		this.question = this.$store.state.testData.questions[this.$props.questionIndex];
		
		this.prepareChoicesForDragNDrop();

		// Náhodné zamíchání možností
		this.shuffle(this.choices);
	},

	methods: {
		/* onEnd: function (evt) {
			console.log(this.$props.question.choices);
		}, */

		...mapActions([
			'correctlyEvaluatedAnswer',
			'incorrectlyEvaluatedAnswer',
		]),

		prepareChoicesForDragNDrop() {
			// Rozparsování
			let parsedAnswer = this.parseChoices(this.question.answer);

			let choiceObject = { id: "", text: "" };
			let id = null;

			parsedAnswer.querySelectorAll("li").forEach((item, index) => {
				id = index + 1;

				let choiceText = this.findAndRenderLaTeX(item.innerHTML);
				choiceObject.text = choiceText;
				choiceObject.id = id;
				this.choices.push(JSON.parse(JSON.stringify(choiceObject)));

				this.rightChoicesOrderArray.push(id);
			});
		},

		evaluateAnswer() {
			this.evaluation.evaluated = true;
			this.evaluation.isCorrect = null; // Vynulování stavu

			// Prvně se určí, zda je pořadí správně -> pokud ano, uloží se do "this.evaluation.isCorrect = true"
			this.choices.forEach((element, index) => {
				if (this.evaluation.isCorrect !== false && element.id === Number(this.rightChoicesOrderArray[index])) {
					this.evaluation.isCorrect = true;
				} else {
					this.evaluation.isCorrect = false;
					this.evaluation.message = 'Vaše odpověď není správná';
				}
			});

			// Následně na základě hodnoty "this.evaluation.isCorrect" se vykonají patřičné kroky
			if (this.evaluation.isCorrect) {
				this.correctlyEvaluatedAnswer(this.$props.questionIndex);
			} else {
				this.incorrectlyEvaluatedAnswer(this.$props.questionIndex);
			}
		}
	},
	
}
</script>